import React from 'react';

// I21 — the top-right ✕ affordance for the dismiss treatment (immediate-x / delayed-x
// cells). Fixed-position so it sits above any paywall's layout regardless of where it's
// rendered in the tree, and consistently top-right across every paywall. `visible` drives
// the delayed-x fade-in; when false the button is transparent and non-interactive so it
// can't be tapped mid-fade.

type DismissCloseButtonProps = {
  visible: boolean;
  onClick: () => void;
};

const DismissCloseButton: React.FC<DismissCloseButtonProps> = ({visible, onClick}) => (
  <button
    type="button"
    aria-label="Close"
    onClick={onClick}
    // Not reachable by keyboard or screen readers until it has faded in (delayed-x).
    disabled={!visible}
    aria-hidden={!visible}
    tabIndex={visible ? 0 : -1}
    style={{
      position: 'fixed',
      top: 'max(12px, env(safe-area-inset-top))',
      right: 12,
      zIndex: 50,
      width: 34,
      height: 34,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: '50%',
      border: 'none',
      background: 'rgba(0,0,0,0.45)',
      cursor: 'pointer',
      padding: 0,
      opacity: visible ? 1 : 0,
      transition: 'opacity 300ms ease',
      pointerEvents: visible ? 'auto' : 'none',
    }}
  >
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M6 6l12 12M18 6L6 18" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" />
    </svg>
  </button>
);

export default DismissCloseButton;
